export function TMapGeoLocation (key) {
  return new Promise(function (resolve, reject) {
    window.init = function () {
      /* eslint-disable */
      resolve(qq)// 注意这里
    }
    var script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = 'https://apis.map.qq.com/tools/geolocation/min?callback=init&referer=survey&key=' + (key || 'xxxx')
    script.onerror = reject
    document.head.appendChild(script)
  })
}



// WEBPACK FOOTER //
// ./src/third/TMapGeoLocation.js